import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/logo.png';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Hide footer on the status page to make QR code scan result cleaner
  if (location.pathname.startsWith('/status/')) {
    return null;
  }
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="AntifurtQR Logo" className="footer-logo-image" />
          </div>
          
          <div className="footer-links">
            <Link to="/">Acasă</Link>
            <Link to="/terms">Termeni și Condiții</Link>
            <Link to="/privacy">Confidențialitate & GDPR</Link>
          </div>
          
          <div className="footer-contact">
            <a href="mailto:contact@antifurt.app">contact@antifurt.app</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} AntifurtQR | Toate drepturile rezervate</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;